import GenericDialog from "../../../../../ui/dialogs/generic-dialog/GenericDialog";
import {Button, Divider, Grid, IconButton, Tooltip, Typography} from "@material-ui/core";
import {Check, Help} from "@material-ui/icons";
import {formatMissingData} from "../../../../../../shared/utils/formatDataUtils";
import PropTypes from "prop-types";
import {useTheme} from "@material-ui/core/styles";
import * as React from "react";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getESimQrDetails} from "../../../../../../store/sim/actions";
import {Skeleton} from "@material-ui/lab";
import {QRCode} from 'react-qrcode-logo';
import icon from "../../../../../../assets/images/qr-fastweb-icon.svg"

const ESimQrDialog = ({open, handleDialogClose, sims, displayMaxNumberOfDownloads}) => {
    const theme = useTheme()
    const dispatch = useDispatch()
    const eSimDetails = useSelector(state => state.simReducer.eSimDetails.data)
    const loading = useSelector(state => state.simReducer.eSimDetails.loading)
    const error = useSelector(state => state.simReducer.eSimDetails.error)
    const [verificaClicked, setVerificaClicked] = useState(false)

    useEffect(() => {
        dispatch(getESimQrDetails(sims[0].seriale))
    }, [dispatch, sims])

    const dialogContent = (
        <Grid container spacing={2}>
            <Grid item md={5} xs={12}>
                <Typography variant='overline'>Profilo eSIM</Typography>
            </Grid>
            <Grid item md={7} xs={12}>
                {!loading ? <Grid container alignItems="center">
                    {eSimDetails.isInstalled ? <Check style={{color: theme.palette.success.dark}}/> : null}
                    <Typography variant='subtitle2'
                                style={
                                    eSimDetails.isInstalled ? {color: theme.palette.success.dark} : {}}
                    >
                        {eSimDetails.profilo}
                    </Typography>
                    {eSimDetails.profiloTooltip && !eSimDetails.isInstalled ?
                        <Tooltip title={eSimDetails.profiloTooltip}
                                 arrow>
                            <IconButton color={"primary"} size={"small"}>
                                <Help fontSize={"small"} color={"primary"}/>
                            </IconButton>
                        </Tooltip> : null}
                </Grid> : <Skeleton height="25px" width="200px" variant="rect"/>}
            </Grid>
            <Divider style={{width: "100%"}}/>
            <Grid item md={5} xs={12}>
                <Typography variant='overline'>esim abilitata</Typography>
            </Grid>
            <Grid item md={7} xs={12}>
                {!loading ? <Grid container alignItems="center">
                    {eSimDetails.isActive ? <Check style={{color: theme.palette.success.dark}}/> : null}
                    <Typography variant='subtitle2'
                                style={
                                    eSimDetails.isActive ? {color: theme.palette.success.dark} : {}}
                    >
                        {eSimDetails.esimAbilitata}
                    </Typography>
                    <Tooltip title={eSimDetails.esimAbilitataTooltip}
                             arrow>
                        <IconButton color={"primary"} size={"small"}>
                            <Help fontSize={"small"} color={"primary"}/>
                        </IconButton>
                    </Tooltip>
                </Grid> : <Skeleton height="25px" width="100px" variant="rect"/>}
            </Grid>
            <Divider style={{width: "100%"}}/>
            {displayMaxNumberOfDownloads ?
                <>
                    <Grid item container md={5} xs={12} alignItems='center'>
                        <Typography variant='overline'>Numero massimo di download raggiunto</Typography>
                    </Grid>

                    <Grid item container md={7} xs={12} alignItems='center'>
                        {!loading ? verificaClicked ? <>
                                <Typography variant='subtitle2'>{eSimDetails.numeroMassimo}</Typography>
                                <Tooltip title={eSimDetails.numeroMassimoTooltip} arrow>
                                    <IconButton color={"primary"} size={"small"}>
                                        <Help fontSize={"small"} color={"primary"}/>
                                    </IconButton>
                                </Tooltip>
                            </> : <Button variant='text'
                                          color='primary' onClick={() => setVerificaClicked(true)}>verifica</Button> :
                            <Skeleton height="25px" width="150px" variant="rect"/>}
                    </Grid>


                    <Divider style={{width: "100%"}}/>
                </> : null}

            <Grid item container md={5} xs={12} alignItems='center'>
                <Typography variant='overline'>eid</Typography>
                <Tooltip title={eSimDetails.eidTooltip} arrow>
                    <IconButton color={"primary"} size={"small"}>
                        <Help fontSize={"small"} color={"primary"}/>
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid item md={7} xs={12}>
                {!loading ? <Typography variant='subtitle2'>{formatMissingData(eSimDetails.eid)}</Typography> :
                    <Skeleton height="25px" width="180px" variant="rect"/>}
            </Grid>
            <Divider style={{width: "100%"}}/>
            <Grid item md={3}>
                {!loading ? <QRCode value={eSimDetails.qrCodeString}
                                    size={200}
                                    logoImage={icon}
                                    logoWidth='40px'
                                    removeQrCodeBehindLogo
                                    logoPadding={2}
                                    logoPaddingStyle='circle'/> :
                    <Skeleton height="200px" width="200px" variant="rect"/>}
            </Grid>
        </Grid>

    )
    return (
        <GenericDialog open={open}
                       handleDialogClose={handleDialogClose}
                       dialogWidth='sm'
                       dialogContent={dialogContent}
                       error={error}
                       handleDialogCloseButton={handleDialogClose}>
            <Typography variant='h5'>{`Dettagli eSIM ${sims[0].numeroDiTelefono ?? ""}`} </Typography>
        </GenericDialog>
    )
}

ESimQrDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired,
    sims: PropTypes.array.isRequired,
    displayMaxNumberOfDownloads: PropTypes.bool.isRequired,
}

export default ESimQrDialog;
